module.exports = __webpack_public_path__ + "img/dt1.fbabe5ed.png";